module.exports = __webpack_public_path__ + "img/close-grey.2a829dab.svg";